import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("p", { class: "text-gray-700" }, "Click the button below to download the daily report", -1);
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("p", { class: "text-gray-700" }, "Click the button below to download the daily leavers report", -1);
import { computed } from 'vue';
import { useStore } from 'vuex';
import httpClient from '@/httpClient';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ReportingDownload',
    setup(__props) {
        const store = useStore();
        const user = computed(() => store.getters.getProfile);
        const handleDownloadReporting = async () => {
            const response = await httpClient.post('/bff/get-report', {
                requestedBy: user.value.userID,
            });
            window.open(response.data.body.signedUrl);
        };
        const handleDownloadLeaversReporting = async () => {
            const response = await httpClient.post('/bff/get-leavers-report', {
                requestedBy: user.value.userID,
            });
            window.open(response.data.body.signedUrl);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _hoisted_1,
                _createTextVNode(),
                _createElementVNode("div", { class: "mt-8 h-80 rounded-lg border-4 border-dashed border-gray-200 p-12 flex items-center" }, [
                    _createElementVNode("button", {
                        class: "w-full p-8 rounded-md bg-green-700 hover:bg-green-800 text-white hover:underline",
                        onClick: handleDownloadReporting
                    }, "Download CSV")
                ]),
                _createTextVNode(),
                _hoisted_2,
                _createTextVNode(),
                _hoisted_3,
                _createTextVNode(),
                _createElementVNode("div", { class: "mt-8 h-80 rounded-lg border-4 border-dashed border-gray-200 p-12 flex items-center" }, [
                    _createElementVNode("button", {
                        class: "w-full p-8 rounded-md bg-green-700 hover:bg-green-800 text-white hover:underline",
                        onClick: handleDownloadLeaversReporting
                    }, "Download CSV")
                ])
            ]));
        };
    }
});
